document.addEventListener('DOMContentLoaded', function () {
	const downloadLink = document.querySelector('.download-card');
	const message = document.querySelector('.downloaded-message');

	if (downloadLink) {
		downloadLink.addEventListener('click', function () {
			if (message) {
				message.classList.add('visible');
				setTimeout(() => {
					message.classList.remove('visible');
				}, 5000);
			}
		});
	}
});
